import { apiPost } from "@/lib/http/client";
import type {
  CreateExportJobFromFiltersRequest,
  CreateExportJobResponse,
} from "@/types/api";

export async function createExportJobFromFilters(
  body: CreateExportJobFromFiltersRequest,
) {
  return apiPost<CreateExportJobResponse>("/export-jobs/from-filters", body);
}
